module.exports = __webpack_public_path__ + "static/lightning-badge-icon-48404e7258bc8570fea958d5d711a1cd.png";